'use strict';

import 'fslightbox';

export function fslightboxInit() {
  const lightboxElements = document.querySelectorAll('.powieksz');

  lightboxElements.forEach((element, index) => {
    element.setAttribute('data-fslightbox', 'custom-gallery');
  });

  refreshFsLightbox();
}
